module.exports = __webpack_public_path__ + "img/img-related13.054fa0d6.jpg";